module.exports = __webpack_public_path__ + "img/icon-promo-yellow.f7c5cdcd.svg";